import { useCallback } from 'react';
import { useHistory } from 'react-router-dom';

import { AccountIntent, useActivation } from '../ActivationContext';
import { useActivationBase } from './useActivationBase';

import { buildRedirectParam } from '@/utils/urlHelpers';

/**
 * Returns a function that navigates to the correct post-auth step based on account intent.
 *   Create intent → /coverage (employer coverage form)
 *   Login intent  → /complete (session handoff)
 *
 * All auth entry points (OTP, email magic link, email+password, access code) should
 * use this hook so the routing logic stays in one place.
 */
const usePostAuthNavigation = () => {
  const { state, dispatch } = useActivation();
  const history = useHistory();
  const base = useActivationBase();

  return useCallback(() => {
    const redirectParam = buildRedirectParam(state.redirectTo);

    if (state.accountIntent === AccountIntent.Create) {
      dispatch({ type: 'SET_STEP', step: 'coverage_form' });
      history.push(`${base}/coverage${redirectParam}`);
    } else {
      dispatch({ type: 'SET_STEP', step: 'activation_complete' });
      history.push(`${base}/complete${redirectParam}`);
    }
  }, [state.accountIntent, state.redirectTo, dispatch, history, base]);
};

export default usePostAuthNavigation;
